export default __webpack_public_path__ + "static/media/fitShape.6c67e615.png";